<!-- <ng-select class="custom" *ngIf="!disable" [items]="companys" bindLabel="name" bindValue="id" [virtualScroll]="true"
    placeholder="{{_placeholder}}" [(ngModel)]="companyId" (ngModelChange)="onChanged()" [selectOnTab]="true" [appendTo]="'body'">
</ng-select> -->

<search-dropdown 
  [items]="companys" 
  [label]="'name'" 
  [uid]="'id'" 
  [placeholder]="_placeholder"
  (afterChange)="onChanged($event)"
  [(ngModel)]="companyId">
</search-dropdown>


<input *ngIf="disable" type="text" [(ngModel)]="companyName" style="width:100%"  class="form-control" [disabled]="true" />
